import keyBy from 'lodash/keyBy';
import extend from 'lodash/extend';
import moment from 'moment';

export class DeliveryCalendar {
  private readonly _calendar;

  constructor(calendar) {
    this._calendar = keyBy(calendar, 'date');
  }

  getDate(date) {
    return this._calendar[moment(date).format('YYYY-MM-DD')];
  }

  extend(calendar) {
    extend(this._calendar, keyBy(calendar, 'date'));
    return this;
  }

  isDateInactive(date: Date | string) {
    const calendarDate = this.getDate(date);
    const isNotDate = !date || !calendarDate;
    return isNotDate || !calendarDate.isActive;
  }

  isFullCapacityDay(date: Date): boolean {
    const calendarDate = this.getDate(date);
    if (!date || !calendarDate) {
      return false;
    }

    return calendarDate.isFullCapacityDay;
  }
}
